var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import uiPalette from "./ui";
var light = __assign({ color: {
        black: {
            label: "",
            value: "#0E0E10",
            category: "common",
        },
        white: {
            label: "",
            value: "#FBFCFD",
            category: "common",
        },
    }, 
    /**
     * ! List of brand colors
     */
    "color-brand-common": {
        black: {
            label: "",
            value: "var(--color-black)",
            category: "theme",
        },
        white: {
            label: "",
            value: "var(--color-white)",
            category: "theme",
        },
    }, "color-brand": {
        // ! --color-brand-primary
        "primary-50": {
            label: "",
            value: "rgb(var(--color-sky-50))",
            category: "theme",
        },
        "primary-100": {
            label: "",
            value: "rgb(var(--color-sky-100))",
            category: "theme",
        },
        "primary-200": {
            label: "",
            value: "rgb(var(--color-sky-200))",
            category: "theme",
        },
        "primary-300": {
            label: "",
            value: "rgb(var(--color-sky-300))",
            category: "theme",
        },
        "primary-400": {
            label: "",
            value: "rgb(var(--color-sky-400))",
            category: "theme",
        },
        "primary-500": {
            label: "",
            value: "rgb(var(--color-sky-500))",
            category: "theme",
        },
        "primary-600": {
            label: "",
            value: "rgb(var(--color-sky-600))",
            category: "theme",
        },
        "primary-700": {
            label: "",
            value: "rgb(var(--color-sky-700))",
            category: "theme",
        },
        "primary-800": {
            label: "",
            value: "rgb(var(--color-sky-800))",
            category: "theme",
        },
        "primary-900": {
            label: "",
            value: "rgb(var(--color-sky-900))",
            category: "theme",
        },
        primary: {
            label: "",
            value: "var(--color-brand-primary-700)",
            category: "theme",
        },
        // --color-brand-indigo
        "indigo-50": {
            label: "",
            value: "rgb(var(--color-indigo-50))",
            category: "theme",
        },
        "indigo-100": {
            label: "",
            value: "rgb(var(--color-indigo-100))",
            category: "theme",
        },
        "indigo-200": {
            label: "",
            value: "rgb(var(--color-indigo-200))",
            category: "theme",
        },
        "indigo-300": {
            label: "",
            value: "rgb(var(--color-indigo-300))",
            category: "theme",
        },
        "indigo-400": {
            label: "",
            value: "rgb(var(--color-indigo-400))",
            category: "theme",
        },
        "indigo-500": {
            label: "",
            value: "rgb(var(--color-indigo-500))",
            category: "theme",
        },
        "indigo-600": {
            label: "",
            value: "rgb(var(--color-indigo-600))",
            category: "theme",
        },
        "indigo-700": {
            label: "",
            value: "rgb(var(--color-indigo-700))",
            category: "theme",
        },
        "indigo-800": {
            label: "",
            value: "rgb(var(--color-indigo-800))",
            category: "theme",
        },
        "indigo-900": {
            label: "",
            value: "rgb(var(--color-indigo-900))",
            category: "theme",
        },
        // --color-brand-blue
        "blue-50": {
            label: "",
            value: "rgb(var(--color-blue-50))",
            catgory: "theme",
        },
        "blue-100": {
            label: "",
            value: "rgb(var(--color-blue-100))",
            catgory: "theme",
        },
        "blue-200": {
            label: "",
            value: "rgb(var(--color-blue-200))",
            catgory: "theme",
        },
        "blue-300": {
            label: "",
            value: "rgb(var(--color-blue-300))",
            catgory: "theme",
        },
        "blue-400": {
            label: "",
            value: "rgb(var(--color-blue-400))",
            catgory: "theme",
        },
        "blue-500": {
            label: "",
            value: "rgb(var(--color-blue-500))",
            catgory: "theme",
        },
        "blue-600": {
            label: "",
            value: "rgb(var(--color-blue-600))",
            catgory: "theme",
        },
        "blue-700": {
            label: "",
            value: "rgb(var(--color-blue-700))",
            catgory: "theme",
        },
        "blue-800": {
            label: "",
            value: "rgb(var(--color-blue-800))",
            catgory: "theme",
        },
        "blue-900": {
            label: "",
            value: "rgb(var(--color-blue-900))",
            catgory: "theme",
        },
        // ! --color-brand-neutral
        "neutral-50": {
            label: "",
            value: "rgb(var(--color-neutral-50))",
            category: "theme",
        },
        "neutral-100": {
            label: "",
            value: "rgb(var(--color-neutral-100))",
            category: "theme",
        },
        "neutral-200": {
            label: "",
            value: "rgb(var(--color-neutral-200))",
            category: "theme",
        },
        "neutral-300": {
            label: "",
            value: "rgb(var(--color-neutral-300))",
            category: "theme",
        },
        "neutral-400": {
            label: "",
            value: "rgb(var(--color-neutral-400))",
            category: "theme",
        },
        "neutral-500": {
            label: "",
            value: "rgb(var(--color-neutral-500))",
            category: "theme",
        },
        "neutral-600": {
            label: "",
            value: "rgb(var(--color-neutral-600))",
            category: "theme",
        },
        "neutral-700": {
            label: "",
            value: "rgb(var(--color-neutral-700))",
            category: "theme",
        },
        "neutral-800": {
            label: "",
            value: "rgb(var(--color-neutral-800))",
            category: "theme",
        },
        "neutral-900": {
            label: "",
            value: "rgb(var(--color-slate-900))",
            category: "theme",
        },
        neutral: {
            label: "",
            value: "var(--color-brand-neutral-500)",
            category: "theme",
        },
        // ! --color-brand-info
        "info-50": {
            label: "",
            value: "rgb(var(--color-violet-50))",
            category: "theme",
        },
        "info-100": {
            label: "",
            value: "rgb(var(--color-violet-100))",
            category: "theme",
        },
        "info-200": {
            label: "",
            value: "rgb(var(--color-violet-200))",
            category: "theme",
        },
        "info-300": {
            label: "",
            value: "rgb(var(--color-violet-300))",
            category: "theme",
        },
        "info-400": {
            label: "",
            value: "rgb(var(--color-violet-400))",
            category: "theme",
        },
        "info-500": {
            label: "",
            value: "rgb(var(--color-violet-500))",
            category: "theme",
        },
        "info-600": {
            label: "",
            value: "rgb(var(--color-violet-600))",
            category: "theme",
        },
        "info-700": {
            label: "",
            value: "rgb(var(--color-violet-700))",
            category: "theme",
        },
        "info-800": {
            label: "",
            value: "rgb(var(--color-violet-800))",
            category: "theme",
        },
        "info-900": {
            label: "",
            value: "rgb(var(--color-violet-900))",
            category: "theme",
        },
        info: {
            label: "",
            value: "var(--color-brand-info-500)",
            category: "theme",
        },
        "info-bg": {
            label: "",
            value: "var(--color-brand-info-50)",
            category: "theme",
        },
        // ! --color-brand-success
        "success-50": {
            label: "",
            value: "rgb(var(--color-emerald-50))",
            category: "theme",
        },
        "success-100": {
            label: "",
            value: "rgb(var(--color-emerald-100))",
            category: "theme",
        },
        "success-200": {
            label: "",
            value: "rgb(var(--color-emerald-200))",
            category: "theme",
        },
        "success-300": {
            label: "",
            value: "rgb(var(--color-emerald-300))",
            category: "theme",
        },
        "success-400": {
            label: "",
            value: "rgb(var(--color-emerald-400))",
            category: "theme",
        },
        "success-500": {
            label: "",
            value: "rgb(var(--color-emerald-50))",
            category: "theme",
        },
        "success-600": {
            label: "",
            value: "rgb(var(--color-emerald-600))",
            category: "theme",
        },
        "success-700": {
            label: "",
            value: "rgb(var(--color-emerald-700))",
            category: "theme",
        },
        "success-800": {
            label: "",
            value: "rgb(var(--color-emerald-800))",
            category: "theme",
        },
        "success-900": {
            label: "",
            value: "rgb(var(--color-emerald-900))",
            category: "theme",
        },
        success: {
            label: "",
            value: "var(--color-brand-success-500)",
            category: "theme",
        },
        "success-bg": {
            label: "",
            value: "var(--color-brand-success-50)",
            category: "theme",
        },
        // ! --color-brand-warning
        "warning-50": {
            label: "",
            value: "rgb(var(--color-amber-50))",
            category: "theme",
        },
        "warning-100": {
            label: "",
            value: "rgb(var(--color-amber-100))",
            category: "theme",
        },
        "warning-200": {
            label: "",
            value: "rgb(var(--color-amber-200))",
            category: "theme",
        },
        "warning-300": {
            label: "",
            value: "rgb(var(--color-amber-300))",
            category: "theme",
        },
        "warning-400": {
            label: "",
            value: "rgb(var(--color-amber-400))",
            category: "theme",
        },
        "warning-500": {
            label: "",
            value: "rgb(var(--color-amber-500))",
            category: "theme",
        },
        "warning-600": {
            label: "",
            value: "rgb(var(--color-amber-600))",
            category: "theme",
        },
        "warning-700": {
            label: "",
            value: "rgb(var(--color-amber-700))",
            category: "theme",
        },
        "warning-800": {
            label: "",
            value: "rgb(var(--color-amber-800))",
            category: "theme",
        },
        "warning-900": {
            label: "",
            value: "rgb(var(--color-amber-900))",
            category: "theme",
        },
        warning: {
            label: "",
            value: "rgb(var(--color-brand-warning-500))",
            category: "theme",
        },
        "warning-bg": {
            label: "",
            value: "rgb(var(--color-brand-warning-50))",
            category: "theme",
        },
        // ! --color-brand-light
        light: {
            label: "",
            value: "var(--color-white)",
            category: "theme",
        },
        // ! --color-brand-dark
        "dark-50": {
            label: "",
            value: "rgb(var(--color-gray-50))",
            category: "theme",
        },
        "dark-100": {
            label: "",
            value: "rgb(var(--color-gray-100))",
            category: "theme",
        },
        "dark-200": {
            label: "",
            value: "rgb(var(--color-gray-200))",
            category: "theme",
        },
        "dark-300": {
            label: "",
            value: "rgb(var(--color-gray-300))",
            category: "theme",
        },
        "dark-400": {
            label: "",
            value: "rgb(var(--color-gray-400))",
            category: "theme",
        },
        "dark-500": {
            label: "",
            value: "rgb(var(--color-gray-500))",
            category: "theme",
        },
        "dark-600": {
            label: "",
            value: "rgb(var(--color-gray-600))",
            category: "theme",
        },
        "dark-700": {
            label: "",
            value: "rgb(var(--color-gray-50))",
            category: "theme",
        },
        "dark-800": {
            label: "",
            value: "var(--color-gray-800))",
            category: "theme",
        },
        "dark-900": {
            label: "",
            value: "var(--color-gray-900))",
            category: "theme",
        },
        black: {
            label: "",
            value: "#000000",
            category: "theme",
        },
        // ! --color-brand-danger
        "danger-50": {
            label: "",
            value: "rgb(var(--color-red-50))",
            category: "theme",
        },
        "danger-100": {
            label: "",
            value: "rgb(var(--color-red-100))",
            category: "theme",
        },
        "danger-200": {
            label: "",
            value: "rgb(var(--color-red-50))",
            category: "theme",
        },
        "danger-300": {
            label: "",
            value: "rgb(var(--color-red-50))",
            category: "theme",
        },
        "danger-400": {
            label: "",
            value: "rgb(var(--color-red-400))",
            category: "theme",
        },
        "danger-500": {
            label: "",
            value: "rgb(var(--color-red-500))",
            category: "theme",
        },
        "danger-600": {
            label: "",
            value: "rgb(var(--color-red-600))",
            category: "theme",
        },
        "danger-700": {
            label: "",
            value: "rgb(var(--color-red-700))",
            category: "theme",
        },
        "danger-800": {
            label: "",
            value: "rgb(var(--color-red-800))",
            category: "theme",
        },
        "danger-900": {
            label: "",
            value: "rgb(var(--color-red-900))",
            category: "theme",
        },
        danger: {
            label: "",
            value: "var(--color-brand-danger-500))",
            category: "theme",
        },
        "danger-bg": {
            label: "",
            value: "rgb(var(--color-brand-danger-50))",
            category: "theme",
        },
        "accent-50": {
            label: "",
            value: "rgb(var(--color-red-50))",
            category: "theme",
        },
        "accent-100": {
            label: "",
            value: "rgb(var(--color-red-100))",
            category: "theme",
        },
        "accent-200": {
            label: "",
            value: "var(--color-red-300))",
            category: "theme",
        },
        "accent-300": {
            label: "",
            value: "rgb(var(--color-red-400))",
            category: "theme",
        },
        "accent-400": {
            label: "",
            value: "rgb(var(--color-red-400))",
            category: "theme",
        },
        "accent-500": {
            label: "",
            value: "rgb(var(--color-red-500))",
            category: "theme",
        },
        "accent-600": {
            label: "",
            value: "rgb(var(--color-red-600))",
            category: "theme",
        },
        "accent-700": {
            label: "",
            value: "rgb(var(--color-red-700))",
            category: "theme",
        },
        "accent-800": {
            label: "",
            value: "rgb(var(--color-red-800))",
            category: "theme",
        },
        "accent-900": {
            label: "",
            value: "rgb(var(--color-red-900))",
            category: "theme",
        },
        accent: {
            label: "",
            value: "rgb(var(--color-brand-accent-500))",
            category: "theme",
        },
    }, 
    /**
     * * List of all available colors
     * ! available as : colors-primary, colors-secondary, ...
     */
    colors: {
        "bg-neutral": {
            label: "label color",
            value: "#f8f8f8",
            category: "general",
        },
        //label
        "drawer-bg": {
            label: " Background Color",
            value: "rgb(var(--color-gray-50))",
            category: "general",
        },
        //text-content
        //facelift
        //subpanel
        /*"subpanel-bg": {
          label: "subpanel background",
          value: `rgb(var(--color-gray-200))`,
          category: "general",
        },*/
        //tabs
        //tab
        //header
        //header
        //footer
        // ! Links
        link: {
            label: "Link color",
            value: "var(--color-brand-primary)",
            category: "colors",
            tags: ["links", "colors"],
        },
        "link--hover": {
            label: "Link color (Hover)",
            value: "var(--color-brand-primary-500)",
            category: "colors",
            tags: ["links", "colors"],
        },
        "link--visited": {
            label: "Link color (Visited)",
            value: "var(--color-brand-primary-500)",
            category: "colors",
            tags: ["links", "colors"],
        },
        "link--focus": {
            label: "Link color (Focus)",
            value: "var(--color-brand-primary-500)",
            category: "colors",
            tags: ["links", "colors"],
        },
        // ! Main
        "bg-default": {
            label: "Default Background Color",
            value: "var(--color-white)",
            category: "general",
        },
        "body-bg": {
            label: " Background Color",
            value: "rgb(var(--color-gray-200))",
            category: "general",
        },
        "body-bg-sec": {
            label: " Background Color",
            value: "rgb(var(--color-gray-100))",
            category: "general",
        },
        //widget
        "widget-border": {
            label: "widget color",
            value: "rgb(var(--color-gray-300))",
        },
        // ! Layouts colors
        "nav-brand-bg": {
            label: "Navbar Brand",
            value: "#3c4b64",
            category: "colors",
        },
        //DOCK
        // ! header && footer
        "header-bg": {
            label: "Header Background Color",
            value: "#ffffff",
            category: "general",
            tags: ["colors"],
        },
        "footer-bg": {
            label: "Footer Background Color",
            value: "#ffffff",
            category: "general",
            tags: ["colors"],
        },
        // ! Borders
        "layout-separator": {
            label: "Layout Separator Color",
            value: "var(--color-brand-dark-200)",
            category: "borders",
        },
        "background-body": {
            label: "Couleur de fond",
            value: "var(--color-brand-common-white)",
            category: "general",
            tags: ["colors"],
        },
        "background-level1": {
            label: "Couleur de fond level1",
            value: "var(--color-brand-neutral-100)",
            category: "general",
            tags: ["colors"],
        },
        "background-level2": {
            label: "Couleur de fond level2",
            value: "var(--color-brand-neutral-200)",
            category: "general",
            tags: ["colors"],
        },
        "background-level3": {
            label: "Couleur de fond level3",
            value: "var(--color-brand-neutral-300)",
            category: "general",
            tags: ["colors"],
        },
        "background-popup": {
            label: "Couleur de popup",
            value: "var(--color-brand-common-white)",
            category: "general",
            tags: ["colors"],
        },
        "background-popup-sec": {
            label: "Couleur de popup",
            value: "var(--color-brand-common-white)",
            category: "general",
            tags: ["colors"],
        },
        "background-surface": {
            label: "Couleur de surface",
            value: "var(--color-brand-neutral-50)",
            category: "general",
            tags: ["colors"],
        },
        "background-tooltip": {
            label: "Couleur de tooltip",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        // danger
        "danger-outlinedActiveBg": {
            label: "Couleur danger de fond du bordure active",
            value: "var(--color-brand-danger-200)",
            category: "general",
            tags: ["colors"],
        },
        "danger-outlinedBorder": {
            label: "Couleur danger de fond du bordure",
            value: "var(--color-brand-danger-300)",
            category: "general",
            tags: ["colors"],
        },
        "danger-outlinedColor": {
            label: "Couleur danger de bordure",
            value: "var(--color-brand-danger-500)",
            category: "general",
            tags: ["colors"],
        },
        "danger-outlinedDisabledBorder": {
            label: "Couleur danger d'outlinedDisabledBorder",
            value: "var(--color-brand-neutral-200)",
            category: "general",
            tags: ["colors"],
        },
        "danger-outlinedDisabledColor": {
            label: "Couleur danger d'outlinedDisabled",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "danger-outlinedHoverBg": {
            label: "Couleur danger d'outlinedHoverBg",
            value: "var(--color-brand-danger-100)",
            category: "general",
            tags: ["colors"],
        },
        "danger-plainActiveBg": {
            label: "Couleur danger de plainActiveBg",
            value: "var(--color-brand-danger-200)",
            category: "general",
            tags: ["colors"],
        },
        "danger-plainColor": {
            label: "Couleur danger de plainColor",
            value: "var(--color-brand-danger-500)",
            category: "general",
            tags: ["colors"],
        },
        "danger-plainDisabledColor": {
            label: "Couleur danger de plainDisabledColor",
            value: "var(--color-brand-danger-400)",
            category: "general",
            tags: ["colors"],
        },
        "danger-plainHoverBg": {
            label: "Couleur danger de plainHoverBg",
            value: "var(--color-brand-danger-100)",
            category: "general",
            tags: ["colors"],
        },
        "danger-softActiveBg": {
            label: "Couleur danger de softActiveBg",
            value: "var(--color-brand-danger-300)",
            category: "general",
            tags: ["colors"],
        },
        "danger-softActiveColor": {
            label: "Couleur danger de softActiveColor",
            value: "var(--color-brand-danger-800)",
            category: "general",
            tags: ["colors"],
        },
        "danger-softBg": {
            label: "Couleur danger de softBg",
            value: "var(--color-brand-danger-100)",
            category: "general",
            tags: ["colors"],
        },
        "danger-softColor": {
            label: "Couleur danger de softColor",
            value: "var(--color-brand-danger-700)",
            category: "general",
            tags: ["colors"],
        },
        "danger-softDisabledBg": {
            label: "Couleur danger de softDisabledBg",
            value: "var(--color-brand-neutral-50)",
            category: "general",
            tags: ["colors"],
        },
        "danger-softDisabledColor": {
            label: "Couleur danger de softDisabledBg",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "danger-softHoverBg": {
            label: "Couleur danger de softHoverBg",
            value: "var(--color-brand-neutral-200)",
            category: "general",
            tags: ["colors"],
        },
        "danger-solidActiveBg": {
            label: "Couleur danger de solidActiveBg",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "danger-solidBg": {
            label: "Couleur danger de solidBg",
            value: "var(--color-brand-danger-500)",
            category: "general",
            tags: ["colors"],
        },
        "danger-solidColor": {
            label: "Couleur danger de solidColor",
            value: "var(--color-brand-common-white)",
            category: "general",
            tags: ["colors"],
        },
        "danger-solidDisabledBg": {
            label: "Couleur danger de solidDisabledBg",
            value: "var(--color-brand-neutral-100)",
            category: "general",
            tags: ["colors"],
        },
        "danger-solidDisabledColor": {
            label: "Couleur danger de solidDisabledColor",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "danger-solidHoverBg": {
            label: "Couleur danger de solidHoverBg",
            value: "var(--color-brand-danger-600)",
            category: "general",
            tags: ["colors"],
        },
        //neutral
        "neutral-outlinedActiveBg": {
            label: "Couleur neutral de outlinedActiveBg",
            value: "var(--color-brand-neutral-200)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-outlinedBorder": {
            label: "Couleur neutral de outlinedBorder",
            value: "var(--color-brand-neutral-300)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-outlinedColor": {
            label: "Couleur neutral de outlinedColor",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-outlinedDisabledBorder": {
            label: "Couleur neutral de outlinedDisabledBorder",
            value: "var(--color-brand-neutral-200)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-outlinedDisabledColor": {
            label: "Couleur neutral de outlinedDisabledColor",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-outlinedHoverBg": {
            label: "Couleur neutral de outlinedHoverBg",
            value: "var(--color-brand-neutral-100)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-plainActiveBg": {
            label: "Couleur neutral de plainActiveBg",
            value: "var(--color-brand-neutral-200)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-plainColor": {
            label: "Couleur neutral de plainColor",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-plainDisabledColor": {
            label: "Couleur neutral de plainDisabledColor",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-plainHoverBg": {
            label: "Couleur neutral de plainHoverBg",
            value: "var(--color-brand-neutral-100)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-plainHoverColor": {
            label: "Couleur neutral de plainHoverColor",
            value: "var(--color-brand-neutral-900)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-softActiveBg": {
            label: "Couleur neutral de softActiveBg",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-softActiveColor": {
            label: "Couleur neutral de softActiveColor",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-softBg": {
            label: "Couleur neutral de softBg",
            value: "var(--color-brand-neutral-100)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-softColor": {
            label: "Couleur neutral de softColor",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-softDisabledBg": {
            label: "Couleur neutral de solidHoverBg",
            value: "var(--color-brand-neutral-100)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-softDisabledColor": {
            label: "Couleur neutral de solidHoverBg",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-softHoverBg": {
            label: "Couleur neutral de softHoverBg",
            value: "var(--color-brand-neutral-200)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-solidActiveBg": {
            label: "Couleur neutral de solidActiveBg",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-solidBg": {
            label: "Couleur neutral de solidBg",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-solidColor": {
            label: "Couleur neutral de solidColor",
            value: "var(--color-brand-common-white)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-solidDisabledBg": {
            label: "Couleur neutral de solidDisabledBg",
            value: "var(--color-brand-neutral-100)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-solidDisabledColor": {
            label: "Couleur neutral de solidDisabledColor",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "neutral-solidHoverBg": {
            label: "Couleur neutral de solidHoverBg",
            value: "var(--color-brand-neutral-600)",
            category: "general",
            tags: ["colors"],
        },
        // primary
        "primary-outlinedActiveBg": {
            label: "Couleur primary d'outlinedActiveBg",
            value: "var(--color-brand-primary-200)",
            category: "general",
            tags: ["colors"],
        },
        "primary-outlinedBorder": {
            label: "Couleur primary d'outlinedBorder",
            value: "var(--color-brand-primary-300)",
            category: "general",
            tags: ["colors"],
        },
        "primary-outlinedColor": {
            label: "Couleur primary d'outlinedColor",
            value: "var(--color-brand-primary-500)",
            category: "general",
            tags: ["colors"],
        },
        "primary-outlinedDisabledBorder": {
            label: "Couleur primary d'outlinedDisabledBorder",
            value: "var(--color-brand-primary-200)",
            category: "general",
            tags: ["colors"],
        },
        "primary-outlinedDisabledColor": {
            label: "Couleur primary d'outlinedDisabledColor",
            value: "var(--color-brand-primary-400)",
            category: "general",
            tags: ["colors"],
        },
        "primary-outlinedHoverBg": {
            label: "Couleur primary d'outlinedHoverBg",
            value: "var(--color-brand-primary-100)",
            category: "general",
            tags: ["colors"],
        },
        "primary-plainActiveBg": {
            label: "Couleur primary de plainActiveBg",
            value: "var(--color-brand-primary-200)",
            category: "general",
            tags: ["colors"],
        },
        "primary-plainColor": {
            label: "Couleur primary de plainColor",
            value: "var(--color-brand-primary-500)",
            category: "general",
            tags: ["colors"],
        },
        "primary-plainDisabledColor": {
            label: "Couleur primary de plainDisabledColor",
            value: "var(--color-brand-primary-400)",
            category: "general",
            tags: ["colors"],
        },
        "primary-plainHoverBg": {
            label: "Couleur primary de plainHoverBg",
            value: "var(--color-brand-primary-100)",
            category: "general",
            tags: ["colors"],
        },
        "primary-softActiveBg": {
            label: "Couleur primary de softActiveBg",
            value: "var(--color-brand-primary-300)",
            category: "general",
            tags: ["colors"],
        },
        "primary-softActiveColor": {
            label: "Couleur primary de softActiveColor",
            value: "var(--color-brand-primary-800)",
            category: "general",
            tags: ["colors"],
        },
        "primary-softBg": {
            label: "Couleur primary de softBg",
            value: "var(--color-brand-primary-100)",
            category: "general",
            tags: ["colors"],
        },
        "primary-softColor": {
            label: "Couleur primary de softColor",
            value: "var(--color-brand-primary-700)",
            category: "general",
            tags: ["colors"],
        },
        "primary-softDisabledBg": {
            label: "Couleur primary de softDisabledBg",
            value: "var(--color-brand-primary-700)",
            category: "general",
            tags: ["colors"],
        },
        "primary-softDisabledColor": {
            label: "Couleur primary de softDisabledColor",
            value: "var(--color-brand-primary-400)",
            category: "general",
            tags: ["colors"],
        },
        "primary-softHoverBg": {
            label: "Couleur primary de softHoverBg",
            value: "var(--color-brand-primary-200)",
            category: "general",
            tags: ["colors"],
        },
        "primary-solidActiveBg": {
            label: "Couleur primary de solidActiveBg",
            value: "var(--color-brand-primary-700)",
            category: "general",
            tags: ["colors"],
        },
        "primary-solidBg": {
            label: "Couleur primary de solidBg",
            value: "var(--color-brand-primary-500)",
            category: "general",
            tags: ["colors"],
        },
        "primary-solidColor": {
            label: "Couleur primary de solidColor",
            value: "var(--color-brand-common-white)",
            category: "general",
            tags: ["colors"],
        },
        "primary-solidDisabledBg": {
            label: "Couleur primary de solidDisabledBg",
            value: "var(--color-brand-neutral-100)",
            category: "general",
            tags: ["colors"],
        },
        "primary-solidDisabledColor": {
            label: "Couleur primary de solidDisabledColor",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "primary-solidHoverBg": {
            label: "Couleur primary de solidHoverBg",
            value: "var(--color-brand-neutral-600)",
            category: "general",
            tags: ["colors"],
        },
        /** Success */
        "success-outlinedActiveBg": {
            label: "Couleur success d'outlinedActiveBg",
            value: "var(--color-brand-success-200)",
            category: "general",
            tags: ["colors"],
        },
        "success-outlinedBorder": {
            label: "Couleur success d'outlinedBorder",
            value: "var(--color-brand-success-300)",
            category: "general",
            tags: ["colors"],
        },
        "success-outlinedColor": {
            label: "Couleur success d'outlinedColor",
            value: "var(--color-brand-success-500)",
            category: "general",
            tags: ["colors"],
        },
        "success-outlinedDisabledBorder": {
            label: "Couleur success d'outlinedDisabledBorder",
            value: "var(--color-brand-neutral-200)",
            category: "general",
            tags: ["colors"],
        },
        "success-outlinedDisabledColor": {
            label: "Couleur success d'outlinedDisabledColor",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "success-outlinedHoverBg": {
            label: "Couleur success d'outlinedHoverBg",
            value: "var(--color-brand-success-100)",
            category: "general",
            tags: ["colors"],
        },
        "success-plainActiveBg": {
            label: "Couleur success de plainActiveBg",
            value: "var(--color-brand-success-200)",
            category: "general",
            tags: ["colors"],
        },
        "success-plainColor": {
            label: "Couleur success de plainColor",
            value: "var(--color-brand-success-500)",
            category: "general",
            tags: ["colors"],
        },
        "success-plainDisabledColor": {
            label: "Couleur success de plainDisabledColor",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "success-plainHoverBg": {
            label: "Couleur success de plainHoverBg",
            value: "var(--color-brand-success-100)",
            category: "general",
            tags: ["colors"],
        },
        "success-softActiveBg": {
            label: "Couleur success de softActiveBg",
            value: "var(--color-brand-success-300)",
            category: "general",
            tags: ["colors"],
        },
        "success-softActiveColor": {
            label: "Couleur success de softActiveColor",
            value: "var(--color-brand-success-800)",
            category: "general",
            tags: ["colors"],
        },
        "success-softBg": {
            label: "Couleur success de softBgr",
            value: "var(--color-brand-success-100)",
            category: "general",
            tags: ["colors"],
        },
        "success-softColor": {
            label: "Couleur success de softColor",
            value: "var(--color-brand-success-700)",
            category: "general",
            tags: ["colors"],
        },
        "success-softDisabledBg": {
            label: "Couleur success de softDisabledBg",
            value: "var(--color-brand-neutral-50)",
            category: "general",
            tags: ["colors"],
        },
        "success-softDisabledColor": {
            label: "Couleur success de softDisabledColor",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "success-softHoverBg": {
            label: "Couleur success de softHoverBg",
            value: "var(--color-brand-success-200)",
            category: "general",
            tags: ["colors"],
        },
        "success-solidActiveBg": {
            label: "Couleur success de solidActiveBg",
            value: "var(--color-brand-success-700)",
            category: "general",
            tags: ["colors"],
        },
        "success-solidBg": {
            label: "Couleur success de solidBg",
            value: "var(--color-brand-success-500)",
            category: "general",
            tags: ["colors"],
        },
        "success-solidColor": {
            label: "Couleur success de solidColor",
            value: "var(--color-brand-common-white)",
            category: "general",
            tags: ["colors"],
        },
        "success-solidDisabledBg": {
            label: "Couleur success de solidDisabledBg",
            value: "var(--color-brand-neutral-100)",
            category: "general",
            tags: ["colors"],
        },
        "success-solidDisabledColor": {
            label: "Couleur success de solidDisabledColor",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "success-solidHoverBg": {
            label: "Couleur success de solidHoverBg",
            value: "var(--color-brand-success-600)",
            category: "general",
            tags: ["colors"],
        },
        // text
        "text-icon": {
            label: "Couleur d'icon",
            value: "var(--color-brand-neutral-500)",
            category: "general",
            tags: ["colors"],
        },
        "text-primary": {
            label: "Couleur de texte primaire",
            value: "var(--color-brand-neutral-800)",
            category: "general",
            tags: ["colors"],
        },
        "text-secondary": {
            label: "Couleur de texte secondaire",
            value: "var(--color-brand-neutral-700)",
            category: "general",
            tags: ["colors"],
        },
        "text-tertiary": {
            label: "Couleur de texte tertiaire",
            value: "var(--color-brand-neutral-600)",
            category: "general",
            tags: ["colors"],
        },
        // warning
        "warning-outlinedActiveBg": {
            label: "Couleur warning d'outlinedActiveBg",
            value: "var(--color-brand-warning-200)",
            category: "general",
            tags: ["colors"],
        },
        "warning-outlinedBorder": {
            label: "Couleur warning d'outlinedBorder",
            value: "var(--color-brand-warning-300)",
            category: "general",
            tags: ["colors"],
        },
        "warning-outlinedColor": {
            label: "Couleur warning d'outlinedColor",
            value: "var(--color-brand-warning-500)",
            category: "general",
            tags: ["colors"],
        },
        "warning-outlinedDisabledBorder": {
            label: "Couleur warning d'outlinedDisabledBorder",
            value: "var(--color-brand-neutral-200)",
            category: "general",
            tags: ["colors"],
        },
        "warning-outlinedDisabledColor": {
            label: "Couleur warning d'outlinedDisabledColor",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "warning-outlinedHoverBg": {
            label: "Couleur warning d'outlinedHoverBg",
            value: "var(--color-brand-warning-100)",
            category: "general",
            tags: ["colors"],
        },
        "warning-plainActiveBg": {
            label: "Couleur warning de plainActiveBg",
            value: "var(--color-brand-warning-200)",
            category: "general",
            tags: ["colors"],
        },
        "warning-plainColor": {
            label: "Couleur warning de plainColor",
            value: "var(--color-brand-warning-500)",
            category: "general",
            tags: ["colors"],
        },
        "warning-plainDisabledColor": {
            label: "Couleur warning de plainDisabledColor",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "warning-plainHoverBg": {
            label: "Couleur warning de plainHoverBg",
            value: "var(--color-brand-warning-100)",
            category: "general",
            tags: ["colors"],
        },
        "warning-softActiveBg": {
            label: "Couleur warning de softActiveBg",
            value: "var(--color-brand-warning-300)",
            category: "general",
            tags: ["colors"],
        },
        "warning-softActiveColor": {
            label: "Couleur warning de softActiveColor",
            value: "var(--color-brand-warning-800)",
            category: "general",
            tags: ["colors"],
        },
        "warning-softBg": {
            label: "Couleur warning de softBg",
            value: "var(--color-brand-warning-100)",
            category: "general",
            tags: ["colors"],
        },
        "warning-softColor": {
            label: "Couleur warning de softColor",
            value: "var(--color-brand-warning-700)",
            category: "general",
            tags: ["colors"],
        },
        "warning-softDisabledBg": {
            label: "Couleur warning de softDisabledBg",
            value: "var(--color-brand-neutral-50)",
            category: "general",
            tags: ["colors"],
        },
        "warning-softDisabledColor": {
            label: "Couleur warning de softDisabledColor",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "warning-softHoverBg": {
            label: "Couleur warning de softHoverBg",
            value: "var(--color-brand-warning-200)",
            category: "general",
            tags: ["colors"],
        },
        "warning-solidActiveBg": {
            label: "Couleur warning de solidActiveBg",
            value: "var(--color-brand-warning-700)",
            category: "general",
            tags: ["colors"],
        },
        "warning-solidBg": {
            label: "Couleur warning de solidBg",
            value: "var(--color-brand-warning-500)",
            category: "general",
            tags: ["colors"],
        },
        "warning-solidColor": {
            label: "Couleur warning de solidColor",
            value: "var(--color-brand-common-white)",
            category: "general",
            tags: ["colors"],
        },
        "warning-solidDisabledBg": {
            label: "Couleur warning de solidDisabledBg",
            value: "var(--color-brand-neutral-100)",
            category: "general",
            tags: ["colors"],
        },
        "warning-solidDisabledColor": {
            label: "Couleur warning de solidDisabledColor",
            value: "var(--color-brand-neutral-400)",
            category: "general",
            tags: ["colors"],
        },
        "warning-solidHoverBg": {
            label: "Couleur warning de solidHoverBg",
            value: "var(--color-brand-warning-600)",
            category: "general",
            tags: ["colors"],
        },
        // ! --color-brand-window-bg --color-brand-window-fg
        "general-background": {
            label: "",
            value: "var(--color-brand-dark-100)",
            category: "theme",
        },
        "general-fg": {
            label: "",
            value: "var(--color-brand-dark-900)",
            category: "theme",
        },
        //buttons
        //primary
        "button-primary-text": {
            value: "#ffffff",
        },
        //secondary
        //link
        "button-link-text": {
            value: "#ffffff",
        },
        //info
        "button-info-text": {
            value: "#ffffff",
        },
        //success
        "button-success-border": {
            value: "rgb(var(--color-green-300))",
        },
        "button-success-text": {
            value: "#ffffff",
        },
        //warning
        "button-warning-text": {
            value: "#ffffff",
        },
        //danger
        "button-danger-text": {
            value: "#ffffff",
        },
        //select option
        "select-option-bg": {
            value: "var(--color-white)",
        },
        "select-option-text": {
            value: "var(--color-black)",
        },
        //input
        "input-bg": {
            value: "var(--color-white)",
        },
        "input-border": {
            value: "rgb(var(--color-gray-200))",
        },
        "input-text": {
            value: "var(--color-black)",
        },
        "input-flag-bg": {
            value: "var(--color-white)",
        },
        "input-flag-bg-sec": {
            value: "rgb(var(--color-gray-100))",
        },
        //Switch icon
        "switch-on-icon": {
            value: "rgb(var(--color-blue-500)",
        },
        "switch-on-bg": {
            value: "rgb(var(--color-blue-300)",
        },
    }, 
    //BORDER
    border: {}, margin: {
    //MENU_NORTH
    //MENU_SOUTH
    //MENU_EAST
    //MENU_WEST
    //DOCK
    //DRAWER
    //Button
    //tabs
    //subpanel
    //widget
    }, 
    //Padding
    padding: {}, 
    /**
     * * List of all available fonts
     */
    fonts: {
        heading: {
            label: "Heading Fonts",
            value: "Roboto, \"Segoe UI\", GeezaPro, \"DejaVu Serif\", \"sans-serif\", \"-apple-system\", BlinkMacSystemFont",
        },
        content: {
            label: "Content Fonts",
            value: "Roboto, \"Segoe UI\", GeezaPro, \"DejaVu Serif\", \"sans-serif\", \"-apple-system\", BlinkMacSystemFont",
        },
    }, 
    /**
     * * List of all available sizes
     */
    sizes: {
        // !fonts
        "font-xx-small": {
            label: "XX-Small Font",
            value: "0.5625em",
            category: "fonts",
        },
        "font-x-small": {
            label: "X-Small Font",
            value: "0.625em",
            category: "fonts",
        },
        "font-small": {
            label: "Small Font",
            value: "0.8333em",
            category: "fonts",
        },
        "font-medium": {
            label: "Medium Font",
            value: "1rem",
            category: "fonts",
        },
        "font-large": {
            label: "Large Font",
            value: "1.125rem",
            category: "fonts",
        },
        "font-x-large": {
            label: "X-Large Font",
            value: "1.5rem",
            category: "fonts",
        },
        "font-xx-large": {
            label: "XX-Large Font",
            value: "2rem",
            category: "fonts",
        },
        // ! Layouts
        "header-height": {
            label: "Header height",
            value: "3.5rem",
            category: "layouts",
        },
        "footer-height": {
            label: "Footer height",
            value: "3rem",
            category: "layouts",
        },
        "vertical-menu-expanded-width": {
            label: "Expanded vertical menu Width",
            value: "16rem",
            category: "layouts",
        },
        "vertical-menu-collapsed-width": {
            label: "Collapsed vertical menu Width",
            value: "3.5rem",
            category: "layouts",
        },
        "horizontal-menu-height": {
            label: "Horizontal menu Height",
            value: "3.5rem",
            category: "layouts",
        },
    } }, uiPalette);
export default light;
